import React from 'react';
import './App.css';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { UserProvider } from './UserContext';
import { HeaderProvider } from './HeaderContext';
import { PreviewProvider } from './PreviewContext';
import TemplateLayout from './main-rating/layouts/TemplateLayout';
import LowRatingPage from './main-rating/pages/lowRating/LowRatingPage';
import LeaveFeedbackPage from './main-rating/pages/highRating/LeaveFeedbackPage';
import { URLS, URLSREL } from './main-rating/constants/urls';

const RatingPage = lazy(() => import('./main-rating/pages/RatingPage'));
const FeedbackPage = lazy(() => import('./main-rating/pages/lowRating/FeedbackPage'));
const ThankYouPage = lazy(() => import('./main-rating/pages/lowRating/ThankYouPage'));
const MainLayout = lazy(() => import('./main-rating/layouts/MainLayout'));

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <UserProvider>
      <HeaderProvider>
        <PreviewProvider>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>              
              {/* Main app routes - all under /app/:id */}
              <Route path="app/:id" element={<TemplateLayout />}>
                <Route index element={<RatingPage />} />
                <Route path={URLSREL.LOW_RATING} element={<LowRatingPage />} />
                <Route path={URLSREL.HIGH_FEEDBACK} element={<LeaveFeedbackPage />} />
                <Route path={URLSREL.LOW_FEEDBACK} element={<FeedbackPage />} />
                <Route path={URLSREL.LOW_THANX} element={<ThankYouPage />} />
              </Route>
              
              {/* Fallback route for root */}
              <Route path="/" element={<div>Please provide a valid survey ID</div>} />
            </Routes>
          </Suspense>
        </PreviewProvider>
      </HeaderProvider>
    </UserProvider>
  );
}

// Wrap App in Router for hooks
export default function AppWithRouter() {
  return (
    <Router>
      <App />
    </Router>
  );
}